import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const cvCandidateList = createAsyncThunk(
    "cvCandidateList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/candidate/fetch-upload-cv-candidate-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate =${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const CvSlice = createSlice({
    name: "CvSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(cvCandidateList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(cvCandidateList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(cvCandidateList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default CvSlice.reducer;
